import { render, staticRenderFns } from "./Dialogs_StoreShopName.vue?vue&type=template&id=2db591bc&scoped=true&"
import script from "./Dialogs_StoreShopName.vue?vue&type=script&lang=js&"
export * from "./Dialogs_StoreShopName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db591bc",
  null
  
)

export default component.exports